import { Component, Input, OnInit, SimpleChanges, inject, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { Permission } from 'src/app/models/principal/permission';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { translate } from '@jsverse/transloco';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ErrorMessageComponent } from 'src/app/components/toastr-templates/error-message/error-message.component';
import { ToastrService as ToastrLibService } from 'ngx-toastr';
import { CustomToastrComponent } from 'src/app/components/toastr-templates/custom-toastr/custom-toastr.component';
import { filter, take } from 'rxjs';
import { TenantOrigin } from 'src/app/models/tenant/tenant-status';

const REQUIRED_PERMISSIONS = [
  Permission.DR_ACTION
];

@Component({
    selector: 'app-tenant-menu',
    templateUrl: './tenant-menu.component.html',
    styleUrls: ['./tenant-menu.component.scss'],
    standalone: false
})
export class TenantMenuComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  @Input() tenantId: any;
  @Input() selectedTenantId: any;

  menuItems: any;
  selectedMenu: any;
  RouterSegments: RouterSegments;
  permissionsMap: { [key: string]: boolean };
  showEdgeNetwork: boolean;
  isProdEnvironment: boolean = window.location.hostname === 'dashboard.bankingcloud.temenos.com';

  constructor(private router: Router, private authService: AuthService, private sidenavService: SidenavService, private toastr: ToastrLibService,
    public permissionsService: PermissionsService, private tenantService: TenantService, private toastrService: CustomToastrService) {
      
    }
    ngOnChanges(changes: SimpleChanges) {
      if (changes['tenantId']) {
        this.ngOnInit();
      }
    }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    if (this.tenantId) {
      this.tenantService.getTenants(this.tenantId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response: any)=> {
          if (response[0]?.targetCloud === 'AWS' || response[0]?.cloudProvider === 'AWS') {
            //this.menuItems = this.menuItems.filter(item => item?.nameKey !== 'LEFT_SIDE_NAV.EDGE_NETWORK');
            this.menuItems = this.menuItems.filter(item => item?.nameKey !== 'LEFT_SIDE_NAV.CERTIFICATE');          }
          if (response[0]?.parameters?.hasSecondaryRegion && response[0]?.parameters?.hasSecondaryRegion === 'false') {
             this.menuItems = this.menuItems.filter(item => item?.nameKey !== 'TENANT_LAYOUT.MENU.DISASTER_RECOVERY');
          }
          },
          (error) => {
            this.toastrService.clear();
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
          });
          
          this.tenantService.tenant$
          .pipe(
            filter((tenant) => tenant != null),
            take(1)
          ).subscribe(tenant => {
          if (tenant?.origin === TenantOrigin.EXTERNAL) {
            this.menuItems = [
            {
              nameKey: 'TENANT_LAYOUT.MENU.DASHBOARD',
              link: 'dashboard',
            },
            {
              nameKey: 'LEFT_SIDE_NAV.SUBSCRIPTION',
              link: 'subscription',
            },
            {
              nameKey: 'LEFT_SIDE_NAV.EDGE_NETWORK',
              link: 'edge-network',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION',
              link: 'blueprints',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.SETTINGS',
              link: 'settings',
            }];
          } else {
            this.menuItems = [
            {
              nameKey: 'TENANT_LAYOUT.MENU.DASHBOARD',
              link: 'dashboard',
            },
            {
              nameKey: 'LEFT_SIDE_NAV.SUBSCRIPTION',
              link: 'subscription',
            },
            {
              nameKey: 'LEFT_SIDE_NAV.EDGE_NETWORK',
              link: 'edge-network',
            },
            {
              nameKey: 'LEFT_SIDE_NAV.CERTIFICATE',
              link: 'certificate',
            },
            {
              nameKey: 'LEFT_SIDE_NAV.SHARED_SERVICES',
              link: 'shared-services',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION',
              link: 'blueprints',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.CONTINUOUS_UPDATE',
              link: 'updates',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.CUSTOM_IMAGE',
              link: 'custom-image',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.DISASTER_RECOVERY',
              link: 'disaster-recovery',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.SOLUTIONS',
              link: 'solutions',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.JUMPBOX',
              link: 'jumpbox',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.SETTINGS',
              link: 'settings',
            },
            {
              nameKey: 'TENANT_LAYOUT.MENU.SCHEDULE',
              link: 'schedule',
            },
            ...(this.isProdEnvironment ? [{
              nameKey: 'TENANT_LAYOUT.MENU.EOL_REPORT',
              link: 'EOLReport',
            }] : [])
            // {
            //   nameKey: 'TENANT_LAYOUT.MENU.EXTERNAL_PACKAGE_UPDATE',
            //   link: 'external-package',
            // }
          ];
          }    
        });
    }

    if (!this.tenantId) {
      this.tenantId = this.selectedTenantId;
    }
  }

  menuItemClicked(item): void {
    if (item.link && this.tenantId) {
      this.sidenavService.tenantSelectedMenu = item.nameKey;
      this.router.navigate(['/',this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, item.link]);
    } else if(!this.tenantId) {
      const message =  translate('SERVICE.INTERNAL_SERVER_ERROR');
      const title = translate('SERVICE.NO_TENANT_ERROR');
        setTimeout(() => {
           const toastRef = this.toastr.show(message, title, {
              toastComponent: CustomToastrComponent,
              toastClass: '',
              positionClass: 'custom-toast-top-right',
              timeOut: 10000,
              easeTime: 100
            });
            if (toastRef.toastRef.componentInstance) {
    toastRef.toastRef.componentInstance.type = 'error';
    }
        }, 500);
    }
  }
}
